// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { IOperation } from '@shared/undo/operation/i-operation';
import { BasePropertyOperation } from './base-property-operation';
import { ProjectModel } from '@project/model/project.model';
import { AdminService } from '../services/admin.service';
import { ConnectionUtils } from '@3d-scene/model3d/util/connection-utils';

export class AddArticlePropertyOperation extends BasePropertyOperation implements IOperation {
  constructor(
    property: PropertyVO,
    private _article: ArticleVO,
    propertyType: string,
    connectionUtils: ConnectionUtils,
    projectModel: ProjectModel,
    adminService: AdminService,
  ) {
    super(property, propertyType, projectModel, connectionUtils, adminService);
  }

  public getQualifiedClassName(): string {
    return 'AddConnectionPropertyOperation';
  }

  public async performRedo(): Promise<void> {
    this.addArticlePropertyToArticle(this._article);
  }

  public async performUndo(): Promise<void> {
    this.removeArticlePropertyFromArticle(this._article);
  }

  public getOperationDescription(): string {
    return 'addArticlepropertyOperation.description';
  }
}
